import { FC } from 'react';

import OrientationImage from '@assets/orientation.png';

import './LandscapeNotifier.scss';

const LandscapeNotifier: FC<{}> = () => {
  return (
    <div className="landscape-notifier">
      <div className="landscape-notifier__content">
        <img
          className="landscape-notifier__image"
          src={OrientationImage}
          alt=""
        />
        <div className="landscape-notifier__title">
          Please rotate to landscape for the best experience
        </div>
      </div>
    </div>
  );
};

export default LandscapeNotifier;
